import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { CheckOutService } from '../../services/checkout.service';
import { DickerSelectListItem } from '../../models/csp.model';
import { CustomerPaymentsOutput, PaymentModel, CurrentUserModel, AccountLedger } from '../../models/account-ledger.model';
import { PaymentApiResponse } from '../../models/check-out.model';
import { CommonService } from '../../services';
import { enterAnimation } from '../../shared/animations.collections';
import { Observable, Subject, Subscription } from 'rxjs';
import { MyAccountService } from '../../services/myAccount.service';
import { AuthService } from '../../services/auth.service';
import { HttpService } from '../../services/http.service';
import { MyoderService } from '../../my-orders/shared/myoder.service';
import { ccform_callback } from '../../shared/JavaScript/paymentform';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

declare const payway: any;

@Component({
    selector: 'app-make-payment',
    animations: [enterAnimation()],
    templateUrl: './make-payment.component.html',
    styleUrls: ['./make-payment.component.css']
})
export class MakePaymentComponent implements OnInit, OnDestroy {

    title = 'Make a Payment';
    setFullWindow = false;
    loadContent = false;
    amount: any;
    editAmount: boolean = true;
    notes: string = '';
    cartId: string;
    paymentMethod: string;
    dropdownList: DickerSelectListItem[];
    selectedWallet: DickerSelectListItem;
    customerPayments: CustomerPaymentsOutput[];
    isValid: boolean;
    customer_number: string;
    name_on_card: string;
    card_scheme: string;
    cardInfo: string;
    paywayUrl: string;
    orderNumber: string = "";
    editOrderNumber: boolean = true;
    orderSuffix: string = "";
    poReference: string = "";
    paymentApiResponse: PaymentApiResponse;
    postPayment: boolean;
    overDue: number;
    current: number;
    total: number;
    //Subscription List
    getDigitalWalletSub$: Subscription;
    getPaymentMethodSub$: Subscription;
    accountLedger: string = "";
    clickBox: string;
    ledger: AccountLedger;
    paymentFor: string = "";
    apiKey: string;
    payWayMessage: string;

    ccValid: boolean = false;

    maxAmount: number = 100000;

    amexMaxAmount: number = 100000;
    public user$: Observable<CurrentUserModel>;
    private destroy$ = new Subject<void>();
    

    @Output() refreshOpenOrders = new EventEmitter();
    urlPath: string;
    paymentMethods = [
        { value: 'default', viewValue: 'CHOOSE A PAYMENT METHOD' },
        { value: 'CreditCard', viewValue: 'Credit card' },
        { value: 'DigitalWallet', viewValue: 'Digital Wallet' }
    ];
    paymentMethodsNZ = [
        { value: 'default', viewValue: 'CHOOSE A PAYMENT METHOD' },
        { value: 'CreditCard', viewValue: 'Credit card' }
    ];
    paymentMethodValue: string;


    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private checkOutService: CheckOutService,
        private myAccountService: MyAccountService,
        private cs: CommonService,
        private orderService: MyoderService,
        private ngProgress: NgProgressService,
        private httpService: HttpService,
        private authService: AuthService
    ) {

    }

    ngOnInit() {
        this.editAmount = true;
        this.editOrderNumber = true;
        this.postPayment = false;
        this.loadContent = false;
        this.clickBox = "total";
        this.paymentMethodValue = "default";
        this.urlPath = this.router.url;
        this.user$ = this.authService.getLoginInfo().pipe(takeUntil(this.destroy$));

        this.activatedRoute.queryParams.subscribe((params: any) => {
            this.urlPath = this.router.url;
            if (this.urlPath.includes('openorders/orderitemdetail')) {
                $('.combination-loader').animate(
                    { scrollLeft: $('#openorders').width() + 2010 },
                    {
                        duration: 400,
                        complete: function () {
                            $('.combination-loader').stop(true, false);
                        }
                    });
            }
            else if (this.urlPath.includes('openorders')) {
                $('.combination-loader').animate(
                    { scrollLeft: $('#openorders').width() + 1184 },
                    {
                        duration: 400,
                        complete: function () {
                            $('.combination-loader').stop(true, false);
                        }
                    });
            }

            if (params && params.paymentFor) {
                this.paymentFor = params.paymentFor;
                this.myAccountService.Payment(params.paymentFor, params.orderNumber, params.orderSuffix, "", "", "", "").subscribe((res: PaymentModel) => {
                    if (res) {
                        this.orderNumber = res.orderNumber;
                        this.amount = parseFloat(res.orderTotal) > 0 ? parseFloat(res.orderTotal).toFixed(2) : 0;
                        this.title = res.title;
                        this.orderSuffix = res.orderSuffix ? res.orderSuffix : "";
                        this.poReference = res.pOReference ? res.pOReference : "";
                        if (this.amount) {
                            this.editAmount = false;
                        }
                        if (this.orderNumber) {
                            this.editOrderNumber = false;
                        }
                        //this.postPayment = true;

                    }
                },
                    (error: any) => {
                        console.error(error);
                        this.loadContent = true;
                    });
            }


        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.activatedRoute.params.subscribe((params: any) => {
            this.urlPath = this.router.url;
            if (params && params.reference && params.reference.length > 0) {
                // this.paymentFor = params.reference.indexOf('BULK') > 0 ? 'bulk' :'order'
                this.myAccountService.Payment("", "", "", "0", params.postPayStatus, params.reference, params.response).subscribe((res: PaymentModel) => {
                    if (res) {
                        let paymentApiResponseModel = {} as PaymentApiResponse;
                        paymentApiResponseModel = {
                            result: "Success",
                            returnType: "",
                            paywayURL: "",
                            message: ""
                        }
                        this.orderService.monitorPaymentChange(paymentApiResponseModel);
                        this.postPayment = true;
                        this.payWayMessage = (res.message && res.message.length > 0) ? res.message : res.errorMessage;
                    }
                },
                    (error: any) => {
                        console.error(error);
                        this.loadContent = true;
                    });
            }
        })

        if (!this.paymentFor || this.paymentFor != "order") {
            this.httpService.getWithNoCache<AccountLedger>('api/MyAccount/GetAccountLedger', null, (res) => {
                this.loadContent = true;
                if (res) {
                    this.ledger = res;
                    this.overDue = this.cs.toNumber((this.cs.toNumber(this.ledger.statementTotals.overDue1) + this.cs.toNumber(this.ledger.statementTotals.overDue2) + this.cs.toNumber(this.ledger.statementTotals.overDue)).toFixed(2));
                    this.current = this.cs.toNumber(this.ledger.statementTotals.current);
                    this.total = this.cs.toNumber(this.ledger.statementTotals.balance);
                    this.amount = this.cs.toNumber(this.total) > 0 ? this.cs.toNumber(this.total) : 0;
                }
            });
        }


        this.getDigitalWalletSub$ = this.checkOutService.GetDigitalWallet().subscribe((res: DickerSelectListItem[]) => {
            this.dropdownList = res;
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.getPaymentMethodSub$ = this.checkOutService.GetPaymentMethodList().subscribe((res: CustomerPaymentsOutput[]) => {
            this.customerPayments = res;
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.myAccountService.GetCurrentPublishableKey().subscribe((key: string) => {
            this.apiKey = key;
        },
            (error: any) => {
                console.error(error);
            });


    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.getDigitalWalletSub$) {
            this.getDigitalWalletSub$.unsubscribe();
        }
        if (this.getPaymentMethodSub$) {
            this.getPaymentMethodSub$.unsubscribe();
        }
    }

    setAmount(amount: number, clickBox: string): void {
        if (amount > 0) {
            this.amount = this.cs.toNumber(amount);
            this.clickBox = clickBox;
        }
    }

    changeAmount() {
        if (this.amount > this.maxAmount) {
            this.cs.implementToast(`The max amount is ${this.maxAmount}`, "Error");
        }
    }

    selectDigitalCard(): void {
        this.cardInfo = this.selectedWallet.text + "/" + this.selectedWallet.value;
        this.name_on_card = this.cardInfo.split('/')[3];
        this.customer_number = this.cardInfo.split('/')[5];

        this.card_scheme = this.cardInfo.split('/')[4];
        if (this.card_scheme && this.card_scheme.length > 0) this.card_scheme = this.card_scheme.trim();
    }

    selectPaymentMethod(): void {
        this.paymentMethod = this.paymentMethodValue == "default" ? "" : this.paymentMethodValue;
        if (this.paymentMethod == "CreditCard") {

            this.showCCForm();
        }
    }

    submitPayment(): void {
        this.isValid = true;

        if (!this.amount) {
            this.cs.showError(".po-reference", "Please enter the amount", "right");
            this.isValid = false;
        }

        if (!this.paymentMethod) {
            this.cs.showError("#next-button", "Please select a payment type to continue", "right");
            this.isValid = false;
        }
        else if (this.paymentMethod == 'DigitalWallet') {
            if (!this.customer_number || !this.name_on_card) {
                this.cs.showError("#selectcard", "Please select or add payment method to continue", "right");
                this.isValid = false;
            }
            else if (!this.customer_number || this.customer_number == 'SELECT') {
                this.cs.showError("#selectcard", "Please select a payment method to continue", "right");
                this.isValid = false;
            }
        }

        if (this.isValid) {
            this.loadContent = false;
            let orderTotal = (Math.round(this.amount * 100) / 100).toFixed(2).toString();

            let notes = this.notes;

            this.myAccountService.ContinueToPayment(this.paymentMethod, this.orderNumber, this.orderSuffix ? this.orderSuffix : "", this.poReference, orderTotal, this.customer_number, this.card_scheme, this.name_on_card, notes).subscribe((res: PaymentApiResponse) => {
                this.paymentApiResponse = res;
                this.loadContent = true;
                this.user$.subscribe(user => {
                    if (this.paymentApiResponse && this.paymentApiResponse.result && this.paymentApiResponse.returnType) {
                        if (this.paymentApiResponse.result.toLowerCase() == "success" && this.paymentApiResponse.returnType.toUpperCase() == "DIGITALWALLET") {
                            this.postPayment = true;
                        }
                        else if (this.paymentApiResponse.result.toLowerCase() == "success" && this.paymentMethod.toUpperCase() == "CREDITCARD" && user?.isAU) {
                            this.postPayment = true;
                        } else if (this.paymentApiResponse.result.toLowerCase() != "success" && this.paymentApiResponse.returnType.toUpperCase() == "DIGITALWALLET") {
                            this.postPayment = false;
                            this.cs.showError("#next-button", this.paymentApiResponse.message, "right");
                        } else if (this.paymentApiResponse.result.toLowerCase() != "success" && this.paymentApiResponse.returnType.toUpperCase() == "CREDITCARD") {
                            this.postPayment = false;
                            this.cs.showError("#payway-cc-submit", this.paymentApiResponse.message, "right");
                        } else if (this.paymentApiResponse.result.toLowerCase() == "success" && this.paymentApiResponse.returnType.toLowerCase() == "payway" && !user?.isAU) {
                            this.paywayUrl = res.paywayURL;
                            window.location.href = this.paywayUrl;
                        } else {
                            this.postPayment = false;
                            this.cs.showError("#next-button", "Payment failed", "right");
                        }
                    } else {
                        this.cs.showError("#next-button", "Payment failed", "right");
                    }
                  });
                
            },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                }
            );
        }
    }

    goToOpenOrder(): void {
        this.orderService.monitorPaymentChange(this.paymentApiResponse);
        if (this.urlPath.includes("myAccount")) {
            this.router.navigate(['/myAccount/openorders'], { relativeTo: this.activatedRoute.parent.parent });
        } else {
            this.router.navigate(['/myOrder/openorders'], { relativeTo: this.activatedRoute.parent.parent });
        }
        // this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }

    makeAnotherPayment(): void {
        this.editAmount = true;
        this.editOrderNumber = true;
        this.postPayment = false;
        this.orderNumber = "";
        this.amount = 0;
        this.title = "Make a Payment";
    }

    isNumberKey(event: any) {
        const pattern = /^[0-9.]+$/;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    close() {
        if (this.accountLedger) {
            this.router.navigateByUrl('/myAccount/accountledger');
        } else if (this.urlPath.includes("openorders")) {
            this.goToOpenOrder();
        } else if (this.urlPath.includes("payment")) {
            if (this.postPayment) {
                this.makeAnotherPayment();
            } else {
                this.router.navigate(['../'], { relativeTo: this.activatedRoute });
            }
        }
        else {
            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        }
    }

    setPaywayCreditCardToken(): void {

        this.ngProgress.start();

        setTimeout(() => {

            this.customer_number = $('#msg').html();

            this.card_scheme = $('#card_type').html();

            if (this.customer_number == undefined || this.customer_number == 'undefined' || this.customer_number.length < 36) {
                this.cs.implementToast('Please verify the credit card number', 'Info');
            }
            else {

                if (this.card_scheme == 'amex' && this.amount > this.amexMaxAmount) {
                    debugger;
                    this.cs.implementToast(`The max amount for American Express is ${this.amexMaxAmount}`, "Error");

                } else {
                   
                    this.submitPayment();
                    
                }

            }

            this.ngProgress.done();
            
        }, 5000);

    }

    showCCForm(): void {

        setTimeout(() => {
            ccform_callback(this.apiKey,
                () => { this.ccValid = true; },
                () => { this.ccValid = false; })
                , 100
        })
    }

}







